import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/image/wx.png';
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "login_mian"
};
const _hoisted_3 = {
  class: "mt-30"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { userLogin } from '../../request/getData';
// import { showFailToast } from 'vant';
import Cookies from 'universal-cookie';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const account = ref('10001');
    const password = ref('123456');
    const cookies = new Cookies();
    const checked = ref(null);
    if (JSON.parse(window.localStorage.getItem('rememberPassword'))) {
      checked.value = window.localStorage.getItem('rememberPassword');
      account.value = window.localStorage.getItem('user');
      password.value = window.localStorage.getItem('password');
    } else {
      window.localStorage.removeItem('rememberPassword');
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('password');
      account.value = '';
      password.value = '';
    }
    const onSubmit = async () => {
      let res = await userLogin({
        account: account.value,
        password: password.value
      });
      console.log(res);
      if (res.code == 1) {
        window.localStorage.setItem('token', res.data.userinfo.token);
        window.localStorage.setItem('mobile', res.data.userinfo.mobile);
        window.localStorage.setItem('username', res.data.userinfo.username);
        router.push('/index');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        onClickLeft: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1)),
        title: "欢迎登录学信网"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_form, {
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: account.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => account.value = $event),
            placeholder: "邮箱/手机号"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => password.value = $event),
            type: "password",
            name: "密码",
            placeholder: "密码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_button, {
          block: "",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 登录 ", -1)]))]),
          _: 1
        }), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "mt-20 flex jc-sb f14 f7f"
        }, [_createElementVNode("p", null, "注册账号"), _createElementVNode("p", null, "忘记密码")], -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "mt-20 tac"
        }, [_createElementVNode("p", {
          class: "f14 f7f mb-20"
        }, "其他登录方式"), _createElementVNode("p", {
          class: "login_img"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })])], -1))])]),
        _: 1
      })])]);
    };
  }
};